<template>
  <div class="bg_white pt16 pb48 pl15 pr15">
    <NavigationBar />
    <!-- <SearchBar class="mt16" /> -->
    <div id="js-article" class="article">
      <Time :date="publicationDate" />
      <h1 class="article_title ab c5a">{{ title }}</h1>
      <div class="hashtag_list">
        <router-link v-for="(val, index) in tagList" :to="{ name: 'ColumnList', query: { resultType: 'hashtag', search: val.tagName, tagId: val.tagId } }" class="hashtag_link ar" :key="index">{{ val.tagName }}</router-link>
      </div>
      <div v-if="displayThumbnail" class="thumbnail"><img :src="thumbnailImagePath" alt=""></div>
      <div class="article_body" v-html="body"></div>

      <MoreButton
       class="more_btn"
      :type="'article_detail'"
      :currentPageNo="currentPageNo"
      :hasNext="hasNext"
      :btnTitle="'次ページ　' + nextPageAnnotation"
      @nextPage="nextPage"
      />

      <div class="pagination">
        <button v-if="currentPageNo != 1" @click="prevPage()" class="pagination_button prev rb">←</button>
        <button class="pagination_button rb" :class="{ 'current': currentPageNo == val }" @click="apiGetArticle(val)" v-for="val in totalPageNo" :disabled="currentPageNo == val" :key="val">{{ val }}</button>
        <button v-if="currentPageNo != totalPageNo" @click="nextPage()" class="pagination_button next rb">→</button>
      </div>

      <div class="article_move_button">
        <button
          v-bind:class="[hasPrevArticleId ? 'article_button' : 'not_available_article_button']"
          @click="hasPrevArticleId ? prevArticlePage() : null"
        >
          <div class="article_prev_arrow">
            <img :src="hasPrevArticleId ? require('@/assets/images/fanclub/arrow_green.png') : require('@/assets/images/fanclub/arrow_gray.png')" alt="prev_arrow">
          </div>
          <div>
            <p class="article_button_msg">前のコラム</p>
          </div>
        </button>
        <div>
          <p class="article_separate"></p>
        </div>
        <button
          v-bind:class="[hasNextArticleId ? 'article_button' : 'not_available_article_button']"
          @click="hasNextArticleId ? nextArticlePage() : null"
        >
          <div>
            <p class="article_button_msg">次のコラム</p>
          </div>
          <div class="article_next_arrow">
            <img :src="hasNextArticleId ? require('@/assets/images/fanclub/arrow_green.png') : require('@/assets/images/fanclub/arrow_gray.png')" alt="prev_arrow">
          </div>
        </button>
      </div>

    </div>
    <RelatedList />
    <HashtagList />

    <AccessRanking />

    <!-- <NavigationBar class="mt24" /> -->
  </div>
</template>

<script>
import Post from '@/components/fanClub/column/Post';
import Time from '@/components/fanClub/column/parts/Time'
import PostList from '@/components/fanClub/column/PostList';
import HashtagList from '@/components/fanClub/column/HashtagList';
import AccessRanking from '@/components/fanClub/column/AccessRanking';
import RelatedList from '@/components/fanClub/column/RelatedList';
import MoreButton from '@/components/fanClub/column/MoreButton';

import TagList from '@/components/api/fanClub/article'
import Config from '@/config/config';
import SearchBar from '@/components/fanClub/column/SearchBar';
import NavigationBar from '@/components/fanClub/column/NavigationBar';

const BaseUrl = Config.APIURL;

export default {
  components: {
    Post,
    Time,
    PostList,
    HashtagList,
    AccessRanking,
    RelatedList,
    MoreButton,
    SearchBar,
    NavigationBar
  },
  data() {
    return {
      title: '',
      body: '',
      publicationDate: '',
      tagList: [],
      thumbnailImagePath: '',
      currentPageNo: null,
      hasNext: false,
      hasNextArticleId: false,
      nextArticleId: '',
      hasPrev: false,
      hasPrevArticleId: false,
      prevArticleId: '',
      nextPageAnnotation: '',
      totalPageNo: null,
      displayThumbnail: false,
    }
  },
  methods: {
    setDate(val) {
      this.title = val.title;
      this.body = val.body;
      this.tagList = val.tagList;
      this.thumbnailImagePath = BaseUrl + val.thumbnailImagePath;
      this.publicationDate = val.publicationDate;
      this.currentPageNo = val.currentPageNo;
      this.hasNext = val.hasNext;
      this.hasNextArticleId = val.hasNextArticleId;
      this.nextArticleId = val.nextArticleId;
      this.hasPrev = val.hasPrev;
      this.hasPrevArticleId = val.hasPrevArticleId;
      this.prevArticleId = val.prevArticleId;
      this.nextPageAnnotation = val.nextPageAnnotation;
      this.totalPageNo = val.totalPageNo;
      this.displayThumbnail = val.displayThumbnail;
      if(this.currentPageNo != 1) {
        this.scrollTop(); // ページの上に移動（アニメーションなし）
      }
    },
    nextPage() {
      this.apiGetArticle(this.currentPageNo + 1);
    },
    prevPage() {
      this.apiGetArticle(this.currentPageNo - 1);
    },
    nextArticlePage() {
      this.$router.push({ name: 'ColumnSingle', params: { articleId: this.nextArticleId } });
    },
    prevArticlePage() {
      this.$router.push({ name: 'ColumnSingle', params: { articleId: this.prevArticleId } });
    },
    scrollTop() {
      let top = document.getElementById('js-article');
      let rect = top.getBoundingClientRect();
      document.documentElement.scrollTop = rect.top + window.pageYOffset;
    },
    async apiGetArticle(pageNum) {
      // console.log(this.$route);
      let data = {
        articleId: this.$route.params.articleId,
        page: pageNum
      }
      await TagList.getArticle(data).then((val) => {
        console.log('記事');
        console.log(val);
        this.setDate(val);
      });
    }
  },
  created() {
    this.apiGetArticle(1);
  },
  watch: {
    $route(to, from) {
      if(to.params.articleId != from.params.articleId) {
        this.apiGetArticle(1);
      }
    }
  }
}
</script>

<style lang="css" scoped>
.article {
  margin-top: 70px;
}
.article_title {
  font-size: 18px;
  margin-top: 8px;
}
.hashtag_list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
}
.hashtag_link {
  font-size: 14px;
  line-height: 1;
  margin-right: 8px;
  margin-bottom: 16px;
}

.thumbnail {
  margin-top: 16px;
}

.article_body {
  margin-top: 24px;
}
>>> .article_body h1,
>>> .article_body h2,
>>> .article_body h3,
>>> .article_body h4,
>>> .article_body h5,
>>> .article_body h6 {
  margin-bottom: 16px;
}
>>> .article_body h1 {
  font-size: 26px;
}
>>> .article_body h2 {
  font-size: 24px;
}
>>> .article_body h3 {
  font-size: 22px;
}
>>> .article_body h4 {
  font-size: 20px;
}
>>> .article_body h5 {
  font-size: 18px;
}
>>> .article_body h6 {
  font-size: 16px;
}
/* >>> .article_body p {
  font-size: 18px;
} */
>>> .article_body a {
  color: rgba(0, 0, 238);
  text-decoration: underline;
}
>>> .article_body figure {
  margin: 16px 0;
}
>>> .article_body img {
  height: auto;
  width: 100%;
}

.more_btn {
  margin-top: 32px;
}

.pagination {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 24px;
}
.pagination_button {
  border: 1px solid #3C96FF;
  background-color: transparent;
  color: #3C96FF;
  font-size: 15px;
  line-height: 1;
  margin: 0 5px;
  padding: 5px;
}
.pagination_button.current {
  background-color: #3C96FF;
  color: #fff;
}

.article_move_button {
  display: flex;
  justify-content: space-around;
  margin-top: 32px;
  border-bottom: #BDBDBD solid 1px;
}

.article_button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 9px;
  border: none;
  background: transparent;
  color: #1DB9B9;
}

.not_available_article_button {
  color: #BDBDBD;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 9px;
  border: none;
  background: transparent;
}

.article_button_msg {
  font-size: 16px;
  margin: 0;
  font-weight: 700;
}

.article_separate {
  width: 1px;
  height: 29px;
  background-color: #BDBDBD;
  margin-bottom: 9px;
}

.article_prev_arrow {
  margin-right: 12px;
  width: 20px;
  height: 20px;
}

.article_next_arrow {
  margin-left: 12px;
  width: 20px;
  height: 20px;
  transform: scale(-1, 1);
}
</style>



// WEBPACK FOOTER //
// src/views/fanClub/column/ColumnDetail.vue